
import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import "./ai.css";

import {
  getLocaleTagCorrente,
  caricaMenuLocale,
  consigliaPiattoAI,
  upsellingAI,
  caricaPreferenzeAI,
} from "../api/aiService";

// Funzione robusta per ottenere il nome piatto
const getNome = (p) =>
  typeof p?.nome === "string"
    ? p.nome
    : (p?.nome?.it || Object.values(p?.nome || {})[0] || "");

function AIConsole() {
const [localeTag, setLocaleTag] = useState("");
const [menu, setMenu] = useState([]);
const [umore, setUmore] = useState("felice");
const [testoLibero, setTestoLibero] = useState("");
const [loading, setLoading] = useState(true);
const [risultatoConsigli, setRisultatoConsigli] = useState(null);
const [risultatoUpsell, setRisultatoUpsell] = useState(null);
const [errore, setErrore] = useState("");


const [preferenzeAI, setPreferenzeAI] = useState(null);
const [piattoSelezionato, setPiattoSelezionato] = useState(null);

const [consiglioLoading, setConsiglioLoading] = useState(false);
const [upsellingLoading, setUpsellingLoading] = useState(false);

/* ----------------------------------------------------------
🔹 CARICAMENTO INIZIALE
---------------------------------------------------------- */
useEffect(() => {
const init = async () => {
try {
setLoading(true);

const tag = await getLocaleTagCorrente();
setLocaleTag(tag);

const prefs = await caricaPreferenzeAI(tag);
setPreferenzeAI(prefs);

const menuLocale = await caricaMenuLocale(tag);
setMenu(menuLocale);

} catch (err) {
console.error("Errore init AI.js:", err);
setErrore(err.message || "Errore nel caricamento dati AI.");
} finally {
setLoading(false);
}
};

init();
}, []);

/* ----------------------------------------------------------
🔹 CONSIGLI AI
---------------------------------------------------------- */
const handleConsiglio = async () => {
  try {
    setErrore("");
    setRisultatoConsigli(null);
    setConsiglioLoading(true);

    if (!menu.length) {
      throw new Error(
        "Menu non disponibile per questo locale (piatti: 0)."
      );
    }

    const preferenze = {
      ...(preferenzeAI || {}),
      umore,
      note: testoLibero || null,
    };

    const res = await consigliaPiattoAI({
      umore,
      menu,
      preferenze,
      localeTag,
    });

    setRisultatoConsigli(res.risultato || null);
  } catch (err) {
    console.error("Errore handleConsiglio:", err);
    setErrore(
      err.message || "Errore durante la richiesta AI."
    );
  } finally {
    setConsiglioLoading(false);
  }
};

/* ----------------------------------------------------------
🔹 UPSELLING AI
---------------------------------------------------------- */
const handleUpselling = async (piatto) => {
  if (!piatto) {
    setErrore("Seleziona un piatto per test upselling.");
    return;
  }

  try {
    setErrore("");
    setRisultatoUpsell(null);
    setUpsellingLoading(true);

    const res = await upsellingAI({
      piatto,
      menu,
      localeTag,
    });

    setRisultatoUpsell(res.risultato || null);
  } catch (err) {
    console.error("Errore handleUpselling:", err);
    setErrore(
      err.message || "Errore durante il test upselling."
    );
  } finally {
    setUpsellingLoading(false);
  }
};

/* ----------------------------------------------------------
🔹 RENDER
---------------------------------------------------------- */
return (
<>
<Navbar />

<div
className={`container page-with-navbar ai-page-root ${
localStorage.getItem("theme") === "dark" ? "dark" : "light"
}`}
>
<div className="ai-hero">
  <div className="ai-hero-badge">
    QrMenu Intelligence
  </div>

  <h1 className="ai-hero-title">
    AI Lab
  </h1>

  <p className="ai-hero-subtitle">
    Simula il comportamento reale del cliente,
    testa upselling intelligenti e scopri
    come l’AI influenza le scelte del menu.
  </p>
</div>

{loading ? (
<p>🔄 Caricamento dati AI…</p>
) : errore ? (
<div className="ai-alert ai-alert-error">{errore}</div>
) : (
<>
{/* LOCALE */}
<div className="ai-active-locale">
  <span className="ai-active-label">
    Locale AI attivo
  </span>

  <strong>{localeTag}</strong>
</div>

{/* SE IL MENU È VUOTO */}
{!menu.length ? (
<div className="ai-alert ai-alert-error">
Nessun piatto trovato nel menu di questo locale.
</div>
) : (
<>
{/* 🧍‍♂️ SIMULAZIONE CLIENTE */}
<div className="ai-card ai-card-neutral">
<h3 style={{ marginTop: 0 }}>🧍‍♂️ Simula cliente</h3>

<div className="ai-group">
  <label>Umore del cliente</label>

  <div className="ai-segment">
    {[
      ["felice", "😄 Felice"],
      ["stressato", "😥 Stressato"],
      ["molto affamato", "🍽️ Affamato"],
      ["romantico", "❤️ Romantico"],
      ["leggero", "🥗 Leggero"],
      ["veloce", "⚡ Veloce"],
    ].map(([value, label]) => (
      <button
        key={value}
        type="button"
        className={`ai-option ${umore === value ? "active" : ""}`}
        onClick={() => setUmore(value)}
      >
        {label}
      </button>
    ))}
  </div>
</div>

<label style={{ marginTop: "0.8rem" }}>
  Nota opzionale (es: “niente pesce”, “spendo massimo 15€”, “voglio qualcosa di leggero”)
</label>
<textarea
value={testoLibero}
onChange={(e) => setTestoLibero(e.target.value)}
className="ai-textarea"
/>

<button
  className="ai-btn ai-btn-success"
  style={{ marginTop: "1rem" }}
  onClick={handleConsiglio}
  disabled={consiglioLoading}
>
  {consiglioLoading ? (
    <span className="ai-loading-content">
      <span className="ai-spinner" />
      L’AI sta preparando i consigli...
    </span>
  ) : (
    "🔮 Genera consigli AI"
  )}
</button>
</div>

{/* RISULTATI CONSIGLI */}
{risultatoConsigli && (
<div
className="ai-card ai-card-success"
style={{ marginTop: "1.5rem" }}
>
<h3>🎉 Risultati suggeriti</h3>

{Array.isArray(risultatoConsigli.consigliati) &&
risultatoConsigli.consigliati.length ? (
risultatoConsigli.consigliati.map((c, idx) => (
            <div className="ai-suggestion-card" key={idx}>
              <div className="ai-suggestion-title">{c.nome}</div>
              <div className="ai-suggestion-meta">
                🍽️ {c.categoria || "N/A"} • 💰 {c.prezzo || "-"}
              </div>
              <div className="ai-suggestion-reason">
                {c.motivo}
              </div>
            </div>
))
) : (
<p>Nessun consiglio dall’AI.</p>
)}
</div>
)}

{/* UPSELLING */}
<div
className="ai-card ai-card-warning"
style={{ marginTop: "2rem" }}
>
<h3>💡 Simulazione Upselling AI</h3>

<p>
Piatto selezionato:{" "}
<strong>{getNome(piattoSelezionato) || "Nessuno"}</strong>
</p>

<div className="menu-dishes-grid">
  {menu.map((p, i) => (
    <div
      key={i}
      className={`dish-option ${getNome(piattoSelezionato) === getNome(p) ? "active" : ""}`}
      // ...solo className, nessuno style inline...
      onClick={() => setPiattoSelezionato(p)}
    >
      {getNome(p)}
    </div>
  ))}
</div>

<button
  disabled={!piattoSelezionato || upsellingLoading}
  className="ai-btn ai-btn-warning"
  onClick={() => handleUpselling(piattoSelezionato)}
>
  {upsellingLoading ? (
    <span className="ai-loading-content">
      <span className="ai-spinner" />
      L’AI sta elaborando l’upselling...
    </span>
  ) : (
    "💡 Genera upselling"
  )}
</button>

{risultatoUpsell && (
<div style={{ marginTop: "1rem" }}>
{risultatoUpsell.upselling && (
<div className="ai-card" style={{ marginBottom: "1rem" }}>
<strong>🔺 Upselling:</strong>{" "}
{risultatoUpsell.upselling.nome}
<br />
<span>{risultatoUpsell.upselling.motivo}</span>
</div>
)}

{risultatoUpsell.cross_selling && (
<div className="ai-card">
<strong>🤝 Cross-selling:</strong>{" "}
{risultatoUpsell.cross_selling.nome}
<br />
<span>{risultatoUpsell.cross_selling.motivo}</span>
</div>
)}
</div>
)}
</div>
</>
)}
</>
)}
</div>
</>
);
}

export default AIConsole;
